import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dashboard from '../components/Menu/Dashboard';
import TaxeRenderBody from '../components/Taxes/TaxeRenderBody';
import TaxePanel from '../components/Taxes/TaxePanel';
import { osName, osVersion, isMobile } from 'react-device-detect';
import StandardDialog from '../components/Complements/StandardDialog';
import DialogOTP from '../components/Complements/DialogOTP';
import TaxeInfoPanel from '../components/Taxes/TaxeInfoPanel';
import TaxesFormReduxForm from '../components/Taxes/TaxesForm';
import { getPeriodsCore } from './../actions/periodsCore'
import { getLevelsCore } from './../actions/levelsCore'
import { getAgreements } from './../actions/agreements'
import { connect } from "react-redux";
import { getDataAgreementsName, getDataAgreementsCode, processPaymentAgreements } from '../services/coreProcess';
import {  createProcessMeterCode } from './../actions/metersCore'
import { feathersCreateData } from '../services';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import { history } from '../helpers/history';
import StandardList from '../components/Complements/StandardList';
import { Button } from '@material-ui/core';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import VoucherTransfersMobile from '../components/Transfers/VoucherTransfersMobile';
import { sendEmailWithVoucher } from "./../actions/sendEmailWithVoucher";
import { urlVoucher } from '../services/urls';
import md5 from 'md5';
import MessageInfo from '../components/Complements/MessageInfo';
import { changeStatusUser } from './../actions/codes'
import { sendLogs } from '../functions/function-logs';
import { getBalanceUser } from "./../actions/balances";
import { validateIp } from '../functions/store';
import { sendMobile } from '../functions/mobile';

const AcademyTaxeContainer = props => {
    const { user, balances, periods, agreements, handleOpenSnack,
         auth, createProcessMeterCode, getPeriodsCore, getAgreements, taxeType, title, sendEmailWithVoucher, taxetitle, devices, agreementType  } = props
    const [ accountSelected, setAccountSelected ] = useState(balances[0])
    // const [ select, setSelect ] = useState(true)
    const [ show, setShow ] = useState(true)
    const [ contAttemptsCreateAcademy, setcontAttemptsCreateAcademy ] = useState(0)
    const [ contAttemptsAcademyProcess, setcontAttemptsAcademyProcess ] = useState(0)
    const [ levels, setLevels ] = useState([])
    const [ loading, setLoading ] = useState(false)
    const [ showvoucher, setShowvoucher ] = useState(false)
    const [ showDialogAccounts, setShowDialogAccounts ] = useState(false)
    const [ dataresponse, setDataresponse ] = useState({})
    const [ taxeInfo, setTaxeInfo ] = useState(taxeType)
    const [dialog, setDialog] = useState({
        state: false,
        title: '',
        content: <div></div>
    })
    //const [ taxeInfo, setTaxeInfo ] = useState(taxeType)
    // const [ taxeList, setTaxeList ] = useState([])
    /* const [ dataList ] = useState([
        {id: '1', primary: 'Seleccione Academia', secondary: '', icon: <AccountBalanceWalletIcon/> },
        {id: '2', primary: 'Buscar Academia', secondary: '', icon: <SearchIcon/>}
    ]) */
    const [ formTaxe, setFormTaxe ] = useState({
        agreements: [],
        levels: [],
        periods: [],
        concept: '',
        description: '',
        payersCode: [],
        payerSelected: [],
        payerValue: 0,
        payerData: {}
    })
    const [ OTP, setOTP ] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    })
    
    // carga inicial
    const mount = () => {
        const unmount = () => {
            if(periods.length === 0) {
                getPeriodsCore().then(res=> {
                }).catch(err => {
                    //console.log(err)
                })
            }
            if(agreements.length === 0) {
                getAgreements().then(res=> {/*console.log('obteniendo agreements',res)*/}).catch(err => {/*console.log('error de agreeents ', err)*/})
            }
            setShow(true)
            if (taxeInfo !== taxeType) {
                setFormTaxe({
                    agreements: [],
                    levels: [],
                    periods: [],
                    concept: '',
                    description: '',
                    payersCode: [],
                    payerSelected: [],
                    payerValue: 0
                })
                setTaxeInfo(taxeType)
            }
        }
        return unmount()
    }

    useEffect(mount,  [auth, handleOpenSnack, getPeriodsCore, getAgreements, periods, taxeType, agreements])
    // functions
    const sum = (key, array) =>  {
        return array.reduce((a, b) => a + (b[key] || 0), 0);
    }
    const cleanDialog = () => {
        setLoading(false)
        setDialog({
            state: false,
            title: '',
            content: <div></div>
        })
    }

    const handleChangeInputOtp = (valueinput) => {
        if(valueinput)
        {dataRefreshToken=valueinput}
        if(valueinput.toString().length === 4){
            handleOTPCompare({data : valueinput.toString()});
        }

    }

    const handleAccountChange = () => {
        setShowDialogAccounts(!showDialogAccounts)
    }

    const handleChangeStatusUser = () => {

        setLoading(true)

        props.changeStatusUser({emited : "NAVCHANGESTATUS", iduser : auth.id}).then(
            response => {
                setLoading(false)
            }
        ).catch(
            error => {
                setLoading(false)
            }
        )
    }

    const handleValidateAttemptsOtp = (cont, typeproccess) => {

        const { parameters, getDeviceData } = props

        let contAttemptsAllowed = (parameters.length > 0) ? filterArrayEqual(parameters, 'name', 'OTP_TRY')[0].value : 5

        cont++;

        switch (typeproccess) {
            case 'CREATEACADEMY':
                setcontAttemptsCreateAcademy(cont)
                break;
            case 'ACADEMY_PROCESS':

                const { concept, payerSelected, payerValue } = formTaxe

                const sendListString = payerSelected.map(function(elem){
                    return elem.Secuencial;
                }).join(";");

                sendLogs(auth.vusk, {
                    type : "PAGO DE "+title.toUpperCase(),
                    data : {
                        CadenaListaRecuadacionesCobradas: sendListString, 
                        SecuencialCuenta: accountSelected.Secuencial,
                        SecuencialEmpresa: 1, 
                        Concepto: concept, 
                        MontoTotal: payerValue, 
                        otpId: OTP.id,
                        NumeroCuentaOrigen : accountSelected.Codigo, 
                        Email : user.CorreoElectronico,
                        TipoServicio : taxetitle, 
                        Codigo : payerSelected[0].CodigoPagador
                    }
                }, 17,devices, getDeviceData)
                setcontAttemptsAcademyProcess(cont)
                break;
            default:
                break;
        }

        if(cont > contAttemptsAllowed){
            setOTP({
                id: '',
                openOtp: false,
                type: '',
                code: ''
            })
            handleChangeStatusUser()
            handleOpenSnack('Se ha excedido el número de intentos permitidos. Por favor contáctese con COOPERATIVA GAÑANSOL llamando al XXXXXXXXX.', 'error');
        }
        
    }
    /* const showFindPanel = () => {
        // setSelect(false)
        setShow(true)
    } */
    /* const showInfoPanel = () => {
        // setSelect(false)
        setShow(true)
    } */
    /* const handleOpenFavorites = () => {
        setDialog({
            state: true,
            title: 'Ingrese descripcion del Medidor',
            content:    <DescriptionFormRedux
                            label="Concepto"
                            positive = {'Aceptar'}
                            onSubmit = {
                                (concept) => {
                                    setFormTaxe(prevState => ({
                                        ...prevState,
                                        concept: concept.data
                                    }))
                                    cleanDialog()
                                    // agregar proceso de peticion de codigo otp para academias
                                    
                                }
                            }
                        />
        })
    } */
    /* const handleAcademySelected = (val) => {
        const {company, code } = val
        getMeterCore({SecuencialEmpresaElectrica: company, CodigoMedidor: code})
        .then(res => {
            setShow(false)
            // setSelect(false)
            cleanDialog()
            // para deshabilitar boton favoritos
            // setFavorites(false)
            // setAcademyInfo(res.payload.data)
            setFormTaxe({
                ...formTaxe,
                code: res.payload.data.NumeroMedidor
            })
        }).catch(err => {
            handleOpenSnack('Medidor no encontrado', 'error')
        })
    } */
    /* const handleListSelected = (val) => {
        const { id } = val
        if (id === '1') {
            setDialog(
                {
                    state: true,
                    title: 'Seleccione Academia',
                    content: <div>
                                <StandardList 
                                dataList={ taxeList }
                                primary={'code'}
                                secondary = { 'description'}
                                icon = { <FlashOnIcon/>}
                                selectItem = { handleAcademySelected }
                                />
                                <Button 
                                fullWidth
                                variant="contained"
                                color="primary" onClick = {() => cleanDialog()}>Cancelar</Button>
                            </div>
                }
            )
        } else {
            showFindPanel()
        }
    } */

    const handleUpdatedBalances = async() => {
        await props.getBalanceUser({NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true}).then( res => {
            
            const { data } = res.payload;
            const getdataaccountselected = data.filter(item => {
                return (item.Secuencial === accountSelected.Secuencial) ? true : false;
                
            })

            setAccountSelected(getdataaccountselected[0])

        })
        .catch(err=> {
            //console.log(' error al obtener balances ', err)
        })
    }

    const handleOTPCompare = async({data}) => {
        // const { id } = auth
        setLoading(true)
        const { type, code } = OTP
        if (type === 'CREATEACADEMY') {
            if (code === data) {
                // const {code, concept, company} = formTaxe
                //crear academia
                setLoading(false)
            } else {
                setLoading(false)
                handleOpenSnack('El código OTP no es correcto. Por favor intente nuevamente.', 'error')
                handleValidateAttemptsOtp(contAttemptsCreateAcademy, 'CREATEACADEMY')
            }
        } else if (type === 'ACADEMY_PROCESS') {
            try {
                if (code === data) {
                    // const { agreements, levels, periods, concept, payerSelected } = formTaxe
                    const { concept, payerSelected, payerValue } = formTaxe
                    //console.log("Pagador: ",payerSelected)
                    const sendListString = payerSelected.map(function(elem){
                        return elem.Secuencial;
                    }).join(";");
                    const { ip } = devices
                    const {getDeviceData, updateIpDevice } = props
                    let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
    
                    // proceso de pago de academia
                    processPaymentAgreements({
                        CadenaListaRecuadacionesCobradas: sendListString, SecuencialCuenta: accountSelected.Secuencial,
                        SecuencialEmpresa: 1, Concepto: concept, MontoTotal: payerValue, otpId: OTP.id,
                         NumeroCuentaOrigen : accountSelected.Codigo, Email : user.CorreoElectronico, NumeroCliente : user.NumeroCliente, ip: ipSend , osName, osVersion,
                          TipoServicio : taxetitle, Codigo : payerSelected[0].CodigoPagador })
                    .then(res => {
                        //console.log(res)
                        handleUpdatedBalances()
                        setDataresponse(res.data)
                        setShowvoucher(true)
                        setLoading(false)
                        handleOpenSnack('Pago realizado con éxito', 'success')
                        setOTP({
                            ...OTP,
                            openOtp: false
                        })
                    })
                    .catch( err => {
                        setLoading(false)
                        setShowvoucher(false)
                        handleOpenSnack(err.message, err.type)
                        setOTP({
                            ...OTP,
                            openOtp: false
                        })
                    })
                } else {
                    setLoading(false)
                    handleOpenSnack('El codigo OTP no es correcto. Por favor intente nuevamente.', 'error')
                    handleValidateAttemptsOtp(contAttemptsAcademyProcess, 'ACADEMY_PROCESS')
                }
            } catch (error) {
                setLoading(false)
                handleOpenSnack('No se ha podido realizar la transferencia.', 'error')
            }
            
            
        }
        
    }
    const handlePeriodSelected = async ({Secuencial}) => {
        const { core } = formTaxe.agreements
        try {
            let lev = await feathersCreateData('core-server', {
                service: 'COLLECTIONS',
                func: 'GET_LEVEL_STUDIES',
                data: {SecuencialInstitucion: core.code, SecuencialPeriodoLectivo: Secuencial}
            })()
            setLevels(lev.data)
        } catch (error) {
            //console.log(error)
        }
    }
    const handleGetAgreementsCode = (SecuencialInstitucion, SecuencialNivelEstudio, CodigoPagador) => {
        try {
            getDataAgreementsCode({
                SecuencialInstitucion, SecuencialNivelEstudio, CodigoPagador}).then(res =>{
                    setLoading(false)
                    setFormTaxe({
                        ...formTaxe,
                        payersCode: res.data,
                        payerData: res.data[0],
                        payerSelected: [res.data[0]]
                    })
                    setShow(false)
                    cleanDialog()
                }).catch(err => {
                    //console.log('Error ', err)
                    setLoading(false)
                    handleOpenSnack(err.message, err.type)
                    setFormTaxe({
                        agreements: [],
                        levels: [],
                        periods: [],
                        concept: '',
                        description: '',
                        payersCode: [],
                        payerSelected: [],
                        payerValue: 0
                    })
                })
        } catch (error) {
            //console.log(error)
            handleOpenSnack('Pagador no encontrado.', 'info')
        }
        
    }
    let dataRefreshToken= null
    const handleSubmit = ({name}) => {
        if(name)
        {dataRefreshToken=name}

        try {
            name=dataRefreshToken
            setLoading(true)
            const { agreements, levels } = formTaxe
            const { code } = agreements.core
            // si es codigo o nombre
            //console.log(/\d/.test(name))
            if (/\d/.test(name)) {
                // busqueda por codigo
                //console.log('busqueda por codigo')
                handleGetAgreementsCode(code, levels.Secuencial, name)
            } else {
                //console.log('busqueda por nombre')
                getDataAgreementsName({
                    SecuencialInstitucion: code, SecuencialNivelEstudio: levels.Secuencial, Nombre: name}).then(res =>{
                        //console.log(res.data)
                        setLoading(false)
                        if (res.data.length > 0) {
                            setDialog({
                                state: true,
                                title: 'Seleccione Pagador',
                                content: <div>
                                    <StandardList 
                                        dataList = {res.data}
                                        key = "CodigoPagador"
                                        primary = "CodigoPagador"
                                        secondary = "NombrePagador"
                                        icon = "account_circle"
                                        selectItem = { (val) => handleGetAgreementsCode(code, levels.Secuencial, val.CodigoPagador)}
                                    />
                                    <Button 
                                        fullWidth
                                        variant="contained"
                                        color="primary" onClick = {() => cleanDialog()}>Cancelar</Button>
                                </div>
                                    
                            })
                        } else {
                            handleOpenSnack('No se ha encontrado pagadores.', 'info')
                            setLoading(false)
                        }
                        
                        /* setFormTaxe({
                            ...formTaxe,
                            payersCode: res.data,
                            payerData: res.data[0],
                            payerSelected: [res.data[0]]
                        })
                        setShow(false) */
                    }).catch(err => {
                        handleOpenSnack(err.message, err.type)
                        setFormTaxe({
                            agreements: [],
                            levels: [],
                            periods: [],
                            concept: '',
                            description: '',
                            payersCode: [],
                            payerSelected: [],
                            payerValue: 0
                        })
                    })
            }
            
        } catch (error) {
            setLoading(false)
            //console.log(error)
            handleOpenSnack('Seleccione todos los parametros.', 'info')
        }
        
    }
    const handleProcessPayment = async( {data}) => {
        try {
            setLoading(true)
            const { payerSelected } = formTaxe
            if ( sum('Valor', payerSelected) >accountSelected.SaldoCuenta) {
                setLoading(false)
                handleOpenSnack('El saldo es insuficiente para realizar la transacción', 'error')
            } else {
                setFormTaxe({
                    ...formTaxe,
                    concept: data,
                    payerValue: sum('Valor', payerSelected)
                })
                const { ip } = devices
                const {getDeviceData, updateIpDevice } = props
                let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                let deviceData =`${osName} ${osVersion}`
                let mac = 'NAVEGADOR'
                if (!isEmpty(devices)) {
                    const { device, ip: ipDevice, mac: macDevice } = devices
                    deviceData = device;
                    ipSend = ipDevice;
                    mac = macDevice;
                } 
                createProcessMeterCode({emited: 'NAVCREATECODE', type: 17, deviceData, ip: ipSend, mac })
                .then(({payload}) => {
                    const { result, data } = payload
                    setOTP({
                        ...OTP,
                        id: data.sequence,
                        code: '' + result,
                        type: 'ACADEMY_PROCESS',
                        openOtp: true
                    })
                    setLoading(false)
                }).catch(err => {
                    setLoading(false)
                    handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
                })
            }
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente', 'error')
        }
        
    }

    const handleSetNewPayment = () => {
        setShowvoucher(false)
        setDataresponse({})
    }

    const handleSendEmailWithVoucher = () => {

        setLoading(true)

        const { CorreoElectronico } = user;

        const { Documento } = dataresponse;

        let object_send_email_with_voucher = {
            Documento : "voucher_"+Documento,
            Email : CorreoElectronico 
        }

        sendEmailWithVoucher(object_send_email_with_voucher).then(
            response => {

                const { message, type } = response.payload;

                setLoading(false)

                handleOpenSnack(message, type);
            }
        ).catch(
            error => {
                setLoading(false)
                handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
            }
        )
    }

    const handleCancelTransferForm = () => {
        history.push('/')
    }

    const handleDownloadVoucher = () => {
        window.open(urlVoucher+md5("voucher_"+dataresponse.Documento)+".pdf", '_blank');
    }

    // renders
    const renderProcess = () => {
        // se renderiza el panel de informacion o el formulario para buscar las academias
        if (show) {
            // render de formulario de busqueda
            return  <TaxesFormReduxForm
                        setFormTaxe = { setFormTaxe }
                        onPeriodSelected = { handlePeriodSelected }
                        onCancelAction = { () => history.push('/')}
                        levels={levels} periods = {periods} agreements= {agreements}
                        formTaxe = { formTaxe}
                        title = { title }
                        onSubmit = {handleSubmit} />
        } else {
            return  <div>
                        {
                            (formTaxe.payersCode.length > 0 ) &&
                            <TaxeInfoPanel
                                select = { formTaxe.payerSelected}
                                options = {formTaxe.payersCode }
                                findValue = { (indexes) => {
                                    let result = []
                                    for (let i = 0; i < indexes + 1; i++) {
                                        result.push(formTaxe.payersCode[i] )
                                    }
                                    setFormTaxe({
                                        ...formTaxe,
                                        payerSelected: result
                                    })
                                }
                                } 
                                payerData = {formTaxe.payerData}
                                getBack = { setShow }
                                processPayment = { handleProcessPayment }
                            />
                        }
                        
                    </div>
        }
    }
    const timeLifeTokenObj = filterArrayEqual(this.props.parameters, 'name', 'TIME_LIFE_TOKEN')
    const timeLifeToken = parseInt(timeLifeTokenObj[0].value)
    const renderBody = () => {
        const {state, title, content} = dialog
        const {openOtp} = OTP
        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return  <UserPanelInfoMobile 
                        user = { user }
                        balances = {
                            balances
                        } 
                        accountSelected = { accountSelected }
                        changeAccount = { setAccountSelected }
                        handleAccountChange = {handleAccountChange}
                        dialog = {showDialogAccounts}
                    >
                        {(showvoucher === false) ? renderProcess() :
                                    <VoucherTransfersMobile
                                        amount = { dataresponse.Valor }
                                        titleheader = { "Valor Cancelado" }
                                        titlebuttonnew = { "Nuevo Pago" }
                                        titleone = { "" }
                                        titletwo = { "" }
                                        databodytwo = { [] }
                                        databodyone = {
                                                        [
                                                            {
                                                                title : "Servicio",
                                                                value : taxetitle,
                                                                order : 1
                                                            },
                                                            {
                                                                title : "Institución",
                                                                value : dataresponse.NombreInstitucion,
                                                                order : 2
                                                            },
                                                            {
                                                                title : "Año lectivo",
                                                                value : dataresponse.AnioLectivo,
                                                                order : 3
                                                            },
                                                            {
                                                                title : "Nivel",
                                                                value : dataresponse.Nivel,
                                                                order : 4
                                                            },
                                                            {
                                                                title : "Mensualidad",
                                                                value : dataresponse.Rubro,
                                                                order : 5
                                                            },
                                                            {
                                                                title : "Código",
                                                                value : dataresponse.Codigo,
                                                                order : 6
                                                            },
                                                            {
                                                                title : "Nombre",
                                                                value : dataresponse.NombrePagador,
                                                                order : 7
                                                            },
                                                            {
                                                                title : "Fecha de pago",
                                                                value : dataresponse.Fecha,
                                                                order : 8
                                                            },
                                                            {
                                                                title : "Dcto. de transacción",
                                                                value : "# "+dataresponse.Documento,
                                                                order : 9
                                                            }
                                                        ]
                                                    }
                                        typesizegrid = {6}
                                        handleSendEmailWithVoucher = { handleSendEmailWithVoucher }
                                        handleCancelTransferForm = { handleCancelTransferForm }
                                        onActionAfter = { handleSetNewPayment }
                                        handleDownloadVoucher = { handleDownloadVoucher }
                                        handleDownloadDevice = { () => {
                                            try {
                                                let send = {
                                                    type: 'action',
                                                    action: 'export_voucher',
                                                    data: urlVoucher+md5("voucher_"+dataresponse.Documento)+".pdf",
                                                    nameFile: md5("voucher_"+dataresponse.Documento),
                                                    extension: 'pdf',
                                                    messageSend: 'Pago de Convenio'
                                                }
                                                sendMobile(JSON.stringify(send))
                                            } catch (error) {
                                                //console.log(error)
                                            }
                                        }}
                                    />
                        }
                        <StandardDialog
                            open = {state}
                            title = {title}
                            handleClose = {() => cleanDialog() } >
                                {content}
                        </StandardDialog>
                        <DialogOTP
                            openDialogOTP= { openOtp }
                            onCloseDialogOTP = { () => setOTP({...OTP, openOtp: false})}
                            initialTime = { Date.now()}
                            loading = {loading}
                            showQR = {false}
                            OTPSubmit = { handleOTPCompare }
                            handleChangeInputOtp = { handleChangeInputOtp }
                            timeLifeToken = { timeLifeToken }
                            refreshToken = { handleSubmit } 
                        />
                    </UserPanelInfoMobile>
            }
            
        } else {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return  <TaxeRenderBody
                        user = { user }
                        balances = {
                            balances
                        } 
                        accountSelected = { accountSelected }
                        changeAccount = { setAccountSelected } >
                        
                            <TaxePanel>
                                { 
                                    (showvoucher === false) ? renderProcess() :
                                    <VoucherTransfersMobile
                                        amount = { dataresponse.Valor }
                                        titleheader = { "Valor Cancelado" }
                                        titlebuttonnew = { "Nuevo Pago" }
                                        titleone = { "" }
                                        titletwo = { "" }
                                        databodytwo = { [] }
                                        databodyone = {
                                                        [
                                                            {
                                                                title : "Servicio",
                                                                value : taxetitle,
                                                                order : 1
                                                            },
                                                            {
                                                                title : "Institución",
                                                                value : dataresponse.NombreInstitucion,
                                                                order : 2
                                                            },
                                                            {
                                                                title : "Año lectivo",
                                                                value : dataresponse.AnioLectivo,
                                                                order : 3
                                                            },
                                                            {
                                                                title : "Nivel",
                                                                value : dataresponse.Nivel,
                                                                order : 4
                                                            },
                                                            {
                                                                title : "Mensualidad",
                                                                value : dataresponse.Rubro,
                                                                order : 5
                                                            },
                                                            {
                                                                title : "Código",
                                                                value : dataresponse.Codigo,
                                                                order : 6
                                                            },
                                                            {
                                                                title : "Nombre",
                                                                value : dataresponse.NombrePagador,
                                                                order : 7
                                                            },
                                                            {
                                                                title : "Fecha de pago",
                                                                value : dataresponse.Fecha,
                                                                order : 8
                                                            },
                                                            {
                                                                title : "Dcto. de transacción",
                                                                value : "# "+dataresponse.Documento,
                                                                order : 9
                                                            }
                                                        ]
                                                    }
                                        typesizegrid = {6}
                                        handleSendEmailWithVoucher = { handleSendEmailWithVoucher }
                                        handleCancelTransferForm = { handleCancelTransferForm }
                                        onActionAfter = { handleSetNewPayment }
                                        handleDownloadVoucher = { handleDownloadVoucher }
                                        handleDownloadDevice = { () => {
                                            try {
                                                let send = {
                                                    type: 'action',
                                                    action: 'export_voucher',
                                                    data: urlVoucher+md5("voucher_"+dataresponse.Documento)+".pdf",
                                                    nameFile: md5("voucher_"+dataresponse.Documento),
                                                    extension: 'pdf',
                                                    messageSend: 'Pago de Convenio'
                                                }
                                                sendMobile(JSON.stringify(send))
                                            } catch (error) {
                                                //console.log(error)
                                            }
                                        }}
                                    />
                                }
                            </TaxePanel>  
                        
                        <StandardDialog
                            open = {state}
                            title = {title}
                            handleClose = {() => cleanDialog() } >
                                {content}
                        </StandardDialog>
                        <DialogOTP
                            openDialogOTP= { openOtp }
                            onCloseDialogOTP = { () => setOTP({...OTP, openOtp: false})}
                            initialTime = { Date.now()}
                            showQR = {false}
                            loading = {loading}
                            OTPSubmit = { handleOTPCompare }
                            handleChangeInputOtp = { handleChangeInputOtp }
                            timeLifeToken = { timeLifeToken }
                        />
                    </TaxeRenderBody>
            }
            
        }
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { agreementType ? renderBody(): <MessageInfo type='info' text={'Servicio no disponible.'} /> }
                multiple = { false }
            />
            <LoadingScreen open={loading} />
        </div>
        
    );
};

AcademyTaxeContainer.propTypes = {
    periods: PropTypes.array.isRequired,
    levels: PropTypes.array.isRequired,
};

export default connect(null, {
    getPeriodsCore,
    getLevelsCore,
    getAgreements,
    createProcessMeterCode,
    sendEmailWithVoucher,
    changeStatusUser,
    getBalanceUser
} )(AcademyTaxeContainer)